import { baseApi } from "configs/store-query";
import {
  GetEmailAddressUserIdentifierAvailabilityApiRequest,
  GetEmailAddressUserIdentifierAvailabilityApiResponse,
  GetUserIdentifierPrimaryTypeApiRequest,
  GetUserIdentifierPrimaryTypeApiResponse,
  GetUserIdentifierSelfApiRequest,
  GetUserIdentifierSelfApiResponse,
} from "apis/user/types/user-identifier-api";
import { USER_IDENTIFIER } from "constants/tags";

const BASE_PATH = "/user-identifiers";

export const userIdentifierController = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSelfUserIdentifier: build.query<
      GetUserIdentifierSelfApiResponse,
      GetUserIdentifierSelfApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/self`,
        method: "GET",
        ...config,
      }),
      providesTags: [USER_IDENTIFIER],
    }),
    getPrimaryTypeUserIdentifier: build.query<
      GetUserIdentifierPrimaryTypeApiResponse,
      GetUserIdentifierPrimaryTypeApiRequest
    >({
      query: ({ path, ...config }) => ({
        url: `${BASE_PATH}/primary/${path.type}`,
        method: "GET",
        ...config,
      }),
      providesTags: [USER_IDENTIFIER],
    }),
    getUserIdentifierEmailAddressAvailability: build.query<
      GetEmailAddressUserIdentifierAvailabilityApiResponse,
      GetEmailAddressUserIdentifierAvailabilityApiRequest
    >({
      query: ({ path, ...config }) => ({
        url: `${BASE_PATH}/${path?.value}/email-address-availability`,
        method: "GET",
        ...config,
      }),
      providesTags: [USER_IDENTIFIER],
    }),
  }),
});
